// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 831) return "static/chunks/831-51df1f37b1104626.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"218":"cc657c6b6fac9363","793":"d70c4132f53cd807"}[chunkId] + ".js";
};